<!--
 * @Descripttion: 虚拟建造产品定价页面底部
 * @version: 
 * @Author: zouxin
 * @email: 1294644276@qq.com
 * @Date: 2024-12-17 16:08:25
 * @LastEditors: zouxin
 * @LastEditTime: 2024-12-19 16:26:43
-->
<template>
  <div class="footer">
    <div class="footContent">
      <img src="~@/assets/logo/bicube.png" alt="" />
      <a-divider type="vertical" style="height: 18px; background-color: #454545" />
      <span class="mark">京ICP备2020034816号-1 Copyright@XXXXXXXX</span>
    </div>
  </div>
</template>
<script>
import '../index.less'
export default {
  name: 'pagefooter',
  data() {
    return {}
  },
}
</script>